/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { filterStyles } from "@insite/content-library/Widgets/MyLists/MyListsFilter";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

filterStyles.container = {
    css: css`
        padding: 15px;
        background: ${getColor("common.background")};
        border: 1px solid ${getColor("common.ui12")};
        margin-top: -11px;
    `,
};

filterStyles.autocompleteGridItem = {
    width: [12, 12, 3, 3, 4],
};

filterStyles.fromGridItem = {
    width: [12, 12, 6, 6, 2],
    css: css`
        > div {
            width: 100%;
            .react-datetime-picker.react-datetime-picker--closed.react-datetime-picker--enabled {
                &:active, &:focus-within {
                    padding: 0;
                }
            }
        }
    `,
};

filterStyles.toGridItem = {
    width: [12, 12, 6, 6, 2],
    css: css`
        > div {
            width: 100%;
            .react-datetime-picker.react-datetime-picker--closed.react-datetime-picker--enabled {
                &:active, &:focus-within {
                    padding: 0;
                }
            }
        }
    `,
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
            margin-top: 27px;
        `,
    },
};

filterStyles.autocompleteGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        > div {
            padding: 0;
            width: 100%;
        }
    `,
};
